// import image from "@/assets/image/dingwei.svg";
// import { baseURL } from "./service/request";
// 防抖
export function Debounce(fn, delay = 2000) {
  let timer = null;
  return function () {
    //借助闭包
    let th = this;
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(th, args);
    }, delay);
  };
}
// 节流
export function Throttle(fn, delay = 2000) {
  let flag = true;
  return function () {
    let th = this;
    let args = arguments;
    if (!flag) {
      //未超过时间间隔，flag无效，不执行fn
      return false;
    }
    fn.apply(th, args);
    flag = false; //在时间间隔内把状态位flag设为无效（false）
    setTimeout(() => {
      flag = true; //超过时间间隔把状态位flag设为有效（true）
    }, delay);
  };
}
// 全屏
export function fullscreen(element) {
  if (document.mozFullScreenEnabled) {
    return Promise.reject(new Error("全屏模式被禁用"));
  }
  let result = null;
  if (element.requestFullscreen) {
    result = element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    result = element.mozRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    result = element.msRequestFullscreen();
  } else if (element.webkitRequestFullscreen) {
    result = element.webkitRequestFullScreen();
  }
  return result || Promise.reject(new Error("不支持全屏"));
}
// 退出全屏
export function cancelFullscreen() {
  if (document.exitFullscreen) {
    if (document.fullscreenElement !== null) {
      document.exitFullscreen();
    }
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}
// 身份证号正则
export function cardReg(t) {
  let value =
    /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
  return value.test(t);
}
// 手机号正则
export function phoneReg(t) {
  let value = /0?(11|12|13|14|15|16|17|18|19)[0-9]{9}/;
  return value.test(t);
}
// // 密码正则
export const passWordReg =
  /^(?=.*\d)(?!.*(\d)\1{2})(?!.*(012|123|234|345|456|567|678|789|987|876|765|654|543|432|321|210))(?=.*[a-zA-Z])(?=.*[^\da-zA-Z\s]).{8,20}$/;

// // promise延迟
export function delay(timeStamp = 1000) {
  return new Promise((resolve, reject) => {
    let timer = setTimeout(() => {
      resolve();
      clearTimeout(timer);
    }, timeStamp);
  });
}
// SEO优化
export function setMeta(title = "", key = "", des = "") {
  let title_default = "";
  if (title) {
    title_default = title;
  }
  document.title = title_default;
  document.querySelector("meta[name='keywords']").setAttribute("content", key);
  document
    .querySelector("meta[name='description']")
    .setAttribute("content", des);
}
// 生成随机验证码
export function getRandomStr(size = 5) {
  const range = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  const strList = [];
  for (let i = 0; i < size; i++) {
    const randomStr = range[Math.floor(Math.random() * range.length)];
    strList.push(randomStr);
  }
  return strList.join("");
}
// 验证码生成base64
export function textBecomeImg(text, fontsize = 20, fontcolor = "#01948e") {
  var canvas = document.createElement("canvas");
  //小于32字加1  小于60字加2  小于80字加4    小于100字加6
  let $buHeight = 0;
  if (fontsize <= 32) {
    $buHeight = 1;
  } else if (fontsize > 32 && fontsize <= 60) {
    $buHeight = 2;
  } else if (fontsize > 60 && fontsize <= 80) {
    $buHeight = 4;
  } else if (fontsize > 80 && fontsize <= 100) {
    $buHeight = 6;
  } else if (fontsize > 100) {
    $buHeight = 10;
  }
  //对于g j 等有时会有遮挡，这里增加一些高度
  canvas.height = fontsize + $buHeight;
  var context = canvas.getContext("2d");
  // 擦除(0,0)位置大小为200x200的矩形，擦除的意思是把该区域变为透明
  context.clearRect(0, 0, canvas.width, canvas.height);
  context.fillStyle = fontcolor;
  context.font = fontsize + "px Arial";
  //top（顶部对齐） hanging（悬挂） middle（中间对齐） bottom（底部对齐） alphabetic是默认值
  context.textBaseline = "Middle";
  context.fillText(text, 0, fontsize / 2);

  //如果在这里直接设置宽度和高度会造成内容丢失 , 暂时未找到原因 , 可以用以下方案临时解决
  //canvas.width = context.measureText(text).width;

  canvas.width = context.measureText(text).width;
  context.fillStyle = fontcolor;
  context.font = fontsize + "px Arial";
  context.textBaseline = "middle";
  context.fillText(text, 0, fontsize / 2);

  var dataUrl = canvas.toDataURL("image/png"); //注意这里背景透明的话，需要使用png
  return dataUrl;
}

// // 获取指定元素到文档顶部的距离
export function getElementToPageTop(el) {
  if (typeof el === "string") {
    el = document.querySelector(el);
  }

  if (el.offsetParent) {
    return getElementToPageTop(el.offsetParent) + el.offsetTop;
  } else {
    return el.offsetTop;
  }
}

// // 创建imgDOM 地图标注点使用
// export function createDOM() {
//   const img = document.createElement("img");
//   img.style.height = "32px";
//   img.style.width = "29px";
//   img.src = image;
//   img.draggable = false;
//   return img;
// }

// // rem布局 根据窗口宽度设置HTML的font-size
// 缓存html字体大小，resize时更新，避免colWidth重复getComputedStyle
let _htmlFontSize = 90;

export function resize() {
  let rem = (window.innerWidth / 1920) * 100,
    fa = 500;
  window.innerWidth < fa && (rem = (fa / 1920) * 100);
  _htmlFontSize = rem;
  document.querySelector("html").style.fontSize = `${rem}px`;
}

// 列宽适配：设计稿 1920px 下的像素值 → 当前屏幕实际 px（数字，用于 el-table-column :width）
export function colWidth(designPx) {
  if (designPx == null) return undefined;
  return Math.round((Number(designPx) / 100) * _htmlFontSize);
}

// // 获取本地存储中的用户信息
export function getUserInfo() {
  if (localStorage.getItem("userInfo")) {
    return JSON.parse(localStorage.getItem("userInfo"));
  } else {
    return null;
  }
}

// // 获取url参数
export function getUrlParams(url) {
  url = url ? url : location.href;

  // 通过 ? 分割获取后面的参数字符串
  let urlStr = url.split("?")[1];
  // 创建空对象存储参数
  let obj = {};
  // 再通过 & 将每一个参数单独分割出来
  let paramsArr = urlStr.split("&");
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    // 再通过 = 将每一个参数分割为 key:value 的形式
    let arr = paramsArr[i].split("=");
    obj[arr[0]] = arr[1];
  }
  return obj;
}

// // 是否为微信内置浏览器
export function isWeixinBrowser() {
  var agent = navigator.userAgent.toLowerCase();
  if (agent.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

// // 是否为移动端
export function isMolibe() {
  if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
}
// 加基础路径
export function AddUrl(content) {
  let url = baseURL;
  let a = [];
  content.split(`src="`).forEach((item, index) => {
    if (index != 0) {
      a.push(`src="${url}${item}`);
    } else {
      a.push(item);
    }
  });
  return a.join("");
}
// // 设置粘贴板内容
export function copy(text) {
  // 创建一个input框
  const input = document.createElement("input");
  // 设置 input框内容
  input.setAttribute("value", text);
  // 添加到body元素中
  document.body.appendChild(input);

  // 将新添加进去的input元素进行选中
  input.select();

  // 为input添加监听事件方便对剪贴板内容进行二次修改
  input.addEventListener("copy", function (event) {
    // 使用ClipboardApi来设置剪贴板里的内容
    var clipboardData = event.clipboardData || window.clipboardData;
    if (!clipboardData) {
      return;
    }
    var text = window.getSelection().toString();
    if (text) {
      event.preventDefault();
      clipboardData.setData("text/plain", text);
    }
  });

  // 执行复制操作
  if (document.execCommand("copy")) {
    // console.log("复制成功");
    document.body.removeChild(input);
    return true;
  } else {
    // console.log("复制失败");
  }

  // document.execCommand('copy') 如果内容复制的不全
  // document.execCommand('copy')前先进行document.execCommand('selectAll')选中所有内容即可

  // 移除input框
  document.body.removeChild(input);
}
const baseurl = "https://jintianjifen.oss-cn-shanghai.aliyuncs.com/";
// 判断图片路径是否带有http
export function includeimg(e) {
  if (!e) {
    return;
  }
  if (e.toString().includes("http")) {
    return e.toString().includes("?")
      ? e
      : e.toString().includes("mp4")
      ? e + "?x-oss-process=image/resize,m_lfit,h_450,w_450"
      : e;
  } else {
    return e.toString().includes("?")
      ? baseurl + e
      : e.toString().includes("mp4")
      ? baseurl + e + "?x-oss-process=image/resize,m_lfit,h_450,w_450"
      : baseurl + e;
  }
}
// 下拉加载
export function handleScroll(e) {
  let dscrollTop =
    document.documentElement.scrollTop || document.body.scrollTop;
  const clientHeight =
    document.documentElement.clientHeight || document.body.clientHeight;
  const pageHeight = e.offsetHeight;
  if (dscrollTop + clientHeight >= pageHeight) {
    return true;
  } else {
    return false;
  }
}
// 大屏化数据单位转换
export function nowSize(value, initWidth = 1920) {
  let nowClientWidth = document.documentElement.clientWidth;
  return value * (nowClientWidth / initWidth);
}
// 取两个时间戳中间的天数
export function intervalTime(startTime) {
  var new_date = new Date(); //新建一个日期对象，默认现在的时间
  var old_date = startTime; //设置过去的一个时间点，"yyyy-MM-dd HH:mm:ss"格式化日期
  var difftime = (new_date - old_date) / 1000; //计算时间差,并把毫秒转换成秒
  var days = parseInt(difftime / 86400); // 天  24*60*60*1000
  var hours = parseInt(difftime / 3600) - 24 * days; // 小时 60*60 总小时数-过去的小时数=现在的小时数
  var minutes = parseInt((difftime % 3600) / 60); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
  var seconds = parseInt(difftime % 60); // 以60秒为一整份 取余 剩下秒数
  return days + "天 ";
}
// 时间格式转换
export function timestampToTime(timestamp) {
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m;
}
export function timestampToTimes(timestamp) {
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return Y + M + D;
}
// 先结or后结
export const postype = "postype";
// 班次id
export const banci = "banci";
// 店铺id
export const storeId = "storeId";
// 商品列表
export const productname = "zfbproname";
export function isEmpty(params) {
  return (
    params === undefined ||
    params === null ||
    params === "" ||
    params === "undefined" ||
    params === "null"
  );
}

export function isNotEmpty(params) {
  return !isEmpty(params);
}
// 获取列表价格总和
export function allsum(arr, key, num) {
  if (arr) {
    // key为单价，num为数量
    return arr.reduce((a, b) => a + (b[key] * b[num] || 0), 0);
  } else {
    return 0;
  }
}
// 支付参数
export const paytype = {
  dinnerType: [
    {
      name: "堂食订单",
      type: 1,
    },
    {
      name: "整单打包",
      type: 2,
    },
  ],
  cutType: [
    {
      name: "无优惠",
      type: 1,
    },
    {
      name: "整单打折",
      type: 2,
    },
    {
      name: "整单减免",
      type: 3,
    },
  ],
};
// 支付方式
export const paylist = [
  {
    name: "全部",
    type: "",
  },
  {
    name: "微信",
    type: "1",
  },
  {
    name: "支付宝",
    type: "2",
  },
  {
    name: "账户余额支付",
    type: "3",
  },
  {
    name: "积分支付",
    type: "4",
  },
  {
    name: "现金支付",
    type: "5",
  },
];
// 订单类型
export const ordertype = [
  {
    name: "全部",
    type: "",
  },
  {
    name: "POS收银",
    type: "pos",
  },
  {
    name: "扫码点餐",
    type: "SC",
  },
];
// 就餐类型
export const Dintype = [
  {
    name: "全部",
    type: "",
  },
  {
    name: "堂食",
    type: "1",
  },
  {
    name: "打包",
    type: "2",
  },
];
// 订单状态
export const dingdstatus = [
  {
    name: "待点餐",
    type: 1,
  },
  {
    name: "备餐中",
    type: 2,
  },
  {
    name: "备餐完成",
    type: 3,
  },
  {
    name: "预结中",
    type: 4,
  },
  {
    name: "已结账",
    type: 5,
  },
  {
    name: "已取消",
    type: 6,
  },
];
// 积分乘0.14
export const storejf = 0.14;
// 积分乘0.2
export const storejfs = 0.2;
// 赠送积分
export function zengs(price, bili) {
  let storebl = bili / 100;
  let money = price - price * storebl;
  return Math.round(money / storejfs);
}

// 退款状态
export const tuiklist = [
  { name: "已提交", type: 0 },
  { name: "待卖家处理", type: 1 },
  { name: "待退回商品", type: 2 },
  { name: "待处理退款", type: 3 },
  { name: "拒绝退款申请", type: 4 },
  { name: "已退款", type: 5 },
];
// 商户平台
// 商户折扣
export function initzhek(e) {
  let rep = /[\.]/;
  let a = e / 10;
  return rep.test(a) ? e + "折送积分" : a + "折送积分";
}
// 付款方式
export const paytypes = [
  {
    value: 1,
    label: "微信支付",
  },
  {
    value: 2,
    label: "支付宝支付",
  },
  {
    value: 3,
    label: "现金账户支付",
  },
  {
    value: 4,
    label: "积分账户支付",
  },
];
// 订单状态
export const orderstatus = [
  {
    label: "全部",
    value: "-1",
  },
  {
    label: "待付款",
    value: "0",
  },
  {
    // 已付款待发货
    label: "待发货",
    value: 1,
  },
  {
    // 已发货待收货
    label: "已发货",
    value: 2,
  },
  {
    // 已收货待评价
    label: "已收货",
    value: 3,
  },
  {
    // 已收货待使用
    label: "待使用",
    value: 4,
  },
  {
    // 已完成待评价
    label: "待评价",
    value: 5,
  },
];
// 提现状态
export const txstatus = [
  {
    value: 0,
    title: "提现申请已提交，请等待后台客服审核",
    name: "待审核",
  },
  {
    value: 1,
    title: "提现成功，请注意查收",
    name: "提现成功",
  },
  {
    value: 2,
    title: "提现申请已提交，保存数据失败",
    name: "已提现，但保存数据失败",
  },
  {
    value: 3,
    title: "提现失败",
    name: "提现失败",
  },
  {
    value: 4,
    title: "提现申请成功，请等待审核",
    name: "等待转账",
  },
];
// 审核状态
export const shstatus = [
  {
    value: 0,
    name: "未审核",
  },
  {
    value: 1,
    name: "已通过",
  },
  {
    value: 2,
    name: "已拒绝",
  },
];
// 配送方式
export const peisong = [
  {
    label: "全国包邮",
    value: 1,
  },
  {
    label: "到店自提",
    value: 2,
  },
  {
    label: "同城配送",
    value: 3,
  },
  {
    label: "到店消费",
    value: 4,
  },
];
// 权益保障
export const quanyi = [
  {
    label: "正品保证",
    value: "1",
  },
  {
    label: "快速发货",
    value: "2",
  },
  {
    label: "售后无忧",
    value: "3",
  },
];
// 商城订单
export const scstatus = [
  {
    value: 0,
    name: "已取消",
  },
  {
    value: 1,
    name: "待付款",
  },
  {
    value: 2,
    name: "待发货",
  },
  {
    value: 3,
    name: "待收货",
  },
  {
    value: 4,
    name: "已收货",
  },
  {
    value: 5,
    name: "已完成",
  },
  {
    value: 9,
    name: "退款中",
  },
  {
    value: 10,
    name: "已退款",
  },
];
// 商城订单
export const scstatuss = [
  {
    value: 0,
    name: "提交申请中",
  },
  {
    value: 1,
    name: "卖家处理中",
  },
  {
    value: 2,
    name: "商品寄回中",
  },
  {
    value: 3,
    name: "等待卖家退款",
  },
  {
    value: 4,
    name: "退款拒绝",
  },
  {
    value: 5,
    name: "退款已完成",
  },
];
// 数组排列组合
export function cartesianProduct(arrays = []) {
  return arrays.reduce(
    (acc, currentArray) => {
      // 如果当前数组为空，直接清空结果（无法生成有效组合）
      if (currentArray.length === 0) return [];
      // 将已有组合与当前数组的元素逐个合并
      return acc.flatMap((combination) =>
        currentArray.map((element) => [...combination, element])
      );
    },
    [[]]
  ); // 初始值是一个包含空组合的数组
}
let arr1 = ["1人份", "2人份"];
let arr2 = ["韩式甜辣", "经典香辣", "芝士奶香"];
let arr3 = ["加肉", "不加肉"];
console.log(cartesianProduct([arr1, arr2, arr3]));



// WEBPACK FOOTER //
// ./src/assets/js/index.js